import { com } from '@eidu/web'
import { useQuery } from '@tanstack/react-query'
import getEntityCount from './api/entity/data/getEntityCount'
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import FieldId = com.eidu.entity.field.FieldId

type UseEntityCountParams = {
  typeId: EntityTypeId
  searchQuery?: string
  filters?: Map<FieldId, string>
}

const useEntityCount = ({ typeId, searchQuery, filters }: UseEntityCountParams): number | undefined => {
  const filtersArray = filters ? Array.from(filters.entries()) : []

  const query = useQuery({
    queryKey: ['entityCount', typeId.toString(), searchQuery ?? '', filtersArray],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      return getEntityCount({
        typeId,
        query: searchQuery,
        filters: filtersArray.map(([fieldId, value]) => ({
          fieldId: fieldId.toString(),
          value,
        })),
        signal,
      })
    },
  })

  return query.data
}

export default useEntityCount
